export default {
  label: {
    placeholder: {
      tableSearch: 'Entre com o User Group para buscar',
      id: 'ID',
      name: 'Grupo',
      expirationDate: 'Data de expiração',
      postLimitPerMonth: 'Capacidade do usergroup',
      edit: 'Alterar',
      save: 'Salvar',
      cancel: 'Cancelar',
      action: 'Ações',
    },
    info: {
      newExpirationDate: 'Caso não queira alterar e permanecer com a data atual, altere a nova data para ficar igual à antiga',
      newCreditValue: 'Caso não queira alterar deixe o campo novo vazio',
      newUserGroup: 'Inicie o cadastro de um novo User Group por "ST_"',
    }
  },
};
